import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import {
  AddTeamMemberDocument,
  AddTeamMemberMutation,
  AddTeamMemberMutationVariables
} from '~/api/graphql';

export const addTeamMember = (
  variables: AddTeamMemberMutationVariables,
  apollo: ApolloClient<NormalizedCacheObject> = client
) =>
  mutateData<AddTeamMemberMutation, AddTeamMemberMutationVariables>(apollo, {
    mutation: AddTeamMemberDocument,
    variables
  });
